const BASE_URL = `/Sitemanagement`

export const getAll = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetERSAll`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const create = async (ERS) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateERSRecord`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(ERS),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const edit = async (ERS) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateERSRecord`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(ERS),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const editAll = async (ERS) => {
    try {
        const res = await fetch(`${BASE_URL}/UpdateERSAllRecords`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(ERS),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const createCategory = async (Category) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateCICRecord`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(Category),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const editCategory = async (Category) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateCICRecord`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(Category),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getAllCategories = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllCategories`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAllIndustries = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllIndustries`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAllSiteFields = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllSiteFields`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const saveSiteFields = async (SiteFieldList) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveSiteFields`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: '{"fields":' + JSON.stringify(SiteFieldList) + '}'
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const saveSiteField = async (SiteField) => {
    try {
        const res = await fetch(`${BASE_URL}/SaveSiteField`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: '{"field":' + JSON.stringify(SiteField) + '}'
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getCountries = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllCountries`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getStates = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllStates`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAttachmentTypes = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/GetAttachmentTypes`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getAttachments = async () => {
    try {
        const res = await fetch(`${BASE_URL}/GetAllAttachments`, {
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttachmentsByType = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/GetAttachmentsByType`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: '{"attachmentTypeName":' + JSON.stringify(reqBody) + '}'
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAttachmentsByName = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/GetAttachmentByName`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: '{"attachmentTypeName":' + JSON.stringify(reqBody) + '}'
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const editAttachment = async (Attachment) => {
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateAttachmentRecord`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(Attachment),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
        throw error
    }
}